<template>

  <v-data-table ref="dataTable"
                :items="antraege"
                :items-per-page="10"
                :headers="headers"
                :search="search"
                :custom-filter="customFilter(['Name', 'Produkt', 'Versicherungsumfang', 'Angebotsnummer'])"
                :sort-by="'Erstellt'"
                :sort-desc="true"
                :footer-props="footerProps"
                locale="de-DE"
                no-data-text="Keine Anträge vorhanden"
                no-results-text="Keine Anträge gefunden"
                must-sort
                class="data--table antraege--table no--hover">


    <!--- data rows ----------------------------------------------------------------------------->
    <template v-slot:item="{item}">
      <tr>

      <td>{{ item.Erstellt | date }}</td>
      <td class="single--line">{{ item.Name }}</td>
      <td>{{ item.Produkt }}</td>
      <td>
        <versicherungsumfang :categories="item.Versicherungsumfang" />
      </td>
      <td>{{ item.Angebotsnummer }}</td>

      <!--- action menue ----------------------------------------------------------------------------->
      <td @click.stop="$emit('details', item.Angebotsnummer)">
        <v-tooltip top nudge-bottom="8">
          <template v-slot:activator="{on}">
            <v-icon v-on="on">insert_drive_file
            </v-icon>
          </template>
          <span class="caption">Antrag in Tab öffnen</span>
        </v-tooltip>
      </td>

      </tr>
    </template>

  </v-data-table>

</template>
<script>
import FiltersMixin from '@/components/kundenverwaltung/FiltersMixin';
import Versicherungsumfang from "@/components/kundenverwaltung/Versicherungsumfang";
import { FOOTER_PROPS } from './tableConfig';

export default {
  name: "OffeneAntraegeTable",
  components: {
    Versicherungsumfang
  },
  mixins: [FiltersMixin],
  props: {
    antraege: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      footerProps: FOOTER_PROPS,
      headers: [
        { text: 'Erstellt', value: 'Erstellt', sortable: true },
        { text: 'Name', value: 'Name', sortable: true },
        { text: 'Produkt', value: 'Produkt', sortable: true },
        { text: 'Versicherungsumfang', value: 'sortableVersicherungsumfang', sortable: true },
        { text: 'Vorgangsnummer', value: 'Angebotsnummer', sortable: true },
        { text: ' ', value: 'actions', sortable: false }
      ]
    };
  }
};
</script>
<style>
.antraege--table.no--hover tr td .icon {
  cursor: pointer !important;
}
</style>
